import { CustomerService } from '../services/customer.service';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { Estate } from '../utils/enum.util';

interface Iphone {
    mobile: string;
    fix: string;
}

interface Iadress {
    name: string;
    city: string;
    country: string;
    code: string;
}

interface Istate {
    firstName: Estate;
    lastName: Estate;
    phoneMobile: Estate;
    phoneFix: Estate;
    adressName: Estate;
    adressCity: Estate;
    adressCountry: Estate;
    adressCode: Estate;
    sexeM: Estate;
    sexeF: Estate;
    mail: Estate;
}

interface Isexe {
    m: boolean;
    f: boolean;
}

interface Iinterested {
    run: boolean;
    accessory: boolean;
    service: boolean;
    vtt: string;
    aubonne: boolean;
    cyclocross: boolean;
    geneve: boolean;
}

export class CustomerModel {

    private _errors: any;
    private _privateId: string;
    private _publicId: string;
    private _firstName: string          = '';
    private _lastName: string           = '';
    private _mail: string               = '';
    private _phone: Iphone              = {mobile: '', fix: ''};
    private _sexe: Isexe                = {m: false, f: false};
    private _adress: Iadress            = {name: '', city: '', country: 'Suisse', code: ''};
    private _comment: string            = '';
    private _looser: boolean            = false;
    private _archive: boolean           = false;
    private _height: number             = null;
    private _weight: number             = null;
    private _crotch: number             = null;
    private _percentageDiscount: number = null;
    //private _seenCount: number;
    //private _creator: string;
    //private _created: string;
    //private _updator: string;
    //private _updated: string;
    private _state: Istate           = {
        firstName    : Estate.Noting,
        lastName     : Estate.Noting,
        adressName   : Estate.Noting,
        adressCity   : Estate.Noting,
        adressCode   : Estate.Noting,
        adressCountry: Estate.Noting,
        phoneMobile  : Estate.Noting,
        phoneFix     : Estate.Noting,
        sexeM        : Estate.Noting,
        sexeF        : Estate.Noting,
        mail         : Estate.Noting
    };
    private _interested: Iinterested = {
        run       : false,
        accessory : false,
        service   : false,
        vtt       : "false",
        aubonne   : false,
        geneve    : false,
        cyclocross: false
    };

    public antiMultiPost:boolean = false;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public customerService: CustomerService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    public modelChange(field: string) {
        //TODO : Anti rebond
        if (this._privateId == undefined) {
            return this.create();
        }
        this.updateOnField(field);
    }

    private updateOnField(field: string) {
        this.state[field] = Estate.Noting;
        if (this.validate() || !this.errors[field]) {
            this.customerService.update(this, field);
        }
    }

    private create() {
        if (this.validate() && !this.antiMultiPost) {
            this.antiMultiPost = true;
            this.customerService.create(this);
        }
        if (this.antiMultiPost)
            console.log('antidoublon');
    }

    public delete() {
        this.customerService.delete(this, 'delete');
    }

    public archiver() {
        this.customerService.delete(this, 'archive');
    }

    public unarchiver() {
        this.customerService.delete(this, 'unarchive');
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    private validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this.firstName, 'firstName', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this.lastName, 'lastName', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}},
            ])
            .addField(this.mail, 'mail', EvalidatorRequire.Optional, [
                {fn: validator.mail, options: {}},
            ])
            .addField(this.phoneMobile, 'phoneMobile', EvalidatorRequire.Optional, [
                {fn: validator.phoneNumber, options: {}}
            ])
            .addField(this.phoneFix, 'phoneFix', EvalidatorRequire.Optional, [
                {fn: validator.phoneNumber, options: {}}
            ])
            .addField(this.phoneFix, 'phoneRequireOnce', EvalidatorRequire.Require, [
                {fn: validator.requireOnce, options: {fieldB: this.phoneMobile, description: 'téléphone'}}
            ])
            .addField(this.height, 'height', EvalidatorRequire.Optional, [
                {fn: validator.integer, options: {min: 1, max: 300}}
            ])
            .addField(this.weight, 'weight', EvalidatorRequire.Optional, [
                {fn: validator.integer, options: {min: 1, max: 300}}
            ])
            .addField(this.percentageDiscount, 'percentageDiscount', EvalidatorRequire.Optional, [
                {fn: validator.integer, options: {min: 0, max: 100}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get privateId(): string {
        return this._privateId;
    }

    set privateId(value: string) {
        this._privateId = value;
    }

    get crotch(): number {
        return this._crotch;
    }

    set crotch(value: number) {
        this._crotch = value;
    }

    get firstName(): string {
        return this._firstName;
    }

    set firstName(value: string) {
        this._firstName = value;
    }

    get lastName(): string {
        return this._lastName;
    }

    set lastName(value: string) {
        this._lastName = value;
    }

    get state(): any {
        return this._state;
    }

    set state(value: any) {
        this._state = value;
    }

    get sexeM(): boolean {
        return this._sexe.m;
    }

    set sexeM(value: boolean) {
        this._sexe.m = value;
    }

    get sexeF(): boolean {
        return this._sexe.f;
    }

    set sexeF(value: boolean) {
        this._sexe.f = value;
    }

    get phoneMobile(): string {
        return this._phone.mobile;
    }

    set phoneMobile(value: string) {
        this._phone.mobile = value;
    }

    get phoneFix(): string {
        return this._phone.fix;
    }

    set phoneFix(value: string) {
        this._phone.fix = value;
    }

    get adressName(): string {
        return this._adress.name;
    }

    set adressName(value: string) {
        this._adress.name = value;
    }

    get adressCode(): string {
        return this._adress.code;
    }

    set adressCode(value: string) {
        this._adress.code = value;
    }

    get adressCity(): string {
        return this._adress.city;
    }

    set adressCity(value: string) {
        this._adress.city = value;
    }

    get adressCountry(): string {
        return this._adress.country;
    }

    set adressCountry(value: string) {
        this._adress.country = value;
    }

    get publicId(): string {
        return this._publicId;
    }

    set publicId(value: string) {
        this._publicId = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get interestedRun(): boolean {
    return this._interested.run;
}

    set interestedRun(value: boolean) {
        this._interested.run = value;
    }

    get interestedAubonne(): boolean {
        return this._interested.aubonne;
    }

    set interestedAubonne(value: boolean) {
        this._interested.aubonne = value;
    }

    get interestedGeneve(): boolean {
        return this._interested.geneve;
    }

    set interestedGeneve(value: boolean) {
        this._interested.geneve = value;
    }

    get interestedCyclocross(): boolean {
        return this._interested.cyclocross;
    }

    set interestedCyclocross(value: boolean) {
        this._interested.cyclocross = value;
    }

    get interestedAccessory(): boolean {
        return this._interested.accessory;
    }

    set interestedAccessory(value: boolean) {
        this._interested.accessory = value;
    }

    get interestedService(): boolean {
        return this._interested.service;
    }

    set interestedService(value: boolean) {
        this._interested.service = value;
    }

    get interestedVTT(): string {
        return this._interested.vtt;
    }

    set interestedVTT(value: string) {
        this._interested.vtt = value;
    }

    get comment(): string {
        return this._comment;
    }

    set comment(value: string) {
        this._comment = value;
    }

    get looser(): boolean {
        return this._looser;
    }

    set looser(value: boolean) {
        this._looser = value;
    }

    get archive(): boolean {
        return this._archive;
    }

    set archive(value: boolean) {
        this._archive = value;
    }

    get mail(): string {
        return this._mail;
    }

    set mail(value: string) {
        this._mail = value;
    }

    get weight(): number {
        return this._weight;
    }

    set weight(value: number) {
        this._weight = value;
    }

    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }

    get percentageDiscount(): number {
        return this._percentageDiscount;
    }

    set percentageDiscount(value: number) {
        this._percentageDiscount = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/customer.model.ts